const headerScroll = () => {
    let myNav = document.querySelector('.navbar');
    window.onscroll = function () {
        if (document.body.scrollTop >= 200 || document.documentElement.scrollTop >= 200 )
        {
            if(!myNav.classList.contains('no-shadow')){
                myNav.classList.add("shadow");
            }

        }
        else {
            myNav.classList.remove("shadow");
        }
    };
}
export default headerScroll;